import { Link } from 'react-router-dom';
import LanguageToggle from '@/components/LanguageToggle';

/**
 * Site-wide footer with the Stripe-compliance disclaimer and legal links.
 * Renders on every route via App.js layout.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0A] mt-12"
    >
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Compliance banner */}
        <div
          data-testid="footer-disclaimer"
          className="bg-[#FFD60A]/5 border border-[#FFD60A]/20 rounded-md p-4 mb-6 text-[11px] text-white/70 leading-relaxed"
        >
          <strong className="text-[#FFD60A]">IMPORTANT:</strong> Parlay Posse is a sports analytics
          and entertainment software platform. We provide AI-powered analysis tools and
          statistical insights only. <strong className="text-white">We do not accept, place, or
          process any wagers.</strong> All betting activity, if any, occurs on third-party
          licensed sportsbooks. We are not a bookmaker, sportsbook, or gambling operator.
          Content is for entertainment purposes only. <strong className="text-white">21+ where
          legally permitted.</strong> Gambling problem? Call <a href="tel:1-800-522-4700"
          className="text-[#FF6B1A] underline">1-800-522-4700</a> or visit{' '}
          <a
            href="https://www.ncpgambling.org"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#FF6B1A] underline"
          >
            ncpgambling.org
          </a>.
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-2">
            <img
              src="/logo-mark.png"
              alt="Parlay Posse"
              width="20"
              height="20"
              className="h-5 w-5"
            />
            <p className="text-xs text-white/40">
              © {year} Parlay Posse. All rights reserved.
            </p>
          </div>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs">
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-white/60 hover:text-[#FF6B1A] transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-white/60 hover:text-[#FF6B1A] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/responsible-play"
              data-testid="footer-responsible-link"
              className="text-white/60 hover:text-[#FF6B1A] transition-colors"
            >
              Responsible Play
            </Link>
            <a
              href="mailto:support@parlayposse.com"
              data-testid="footer-contact-link"
              className="text-white/60 hover:text-[#FF6B1A] transition-colors"
            >
              Contact
            </a>
            <LanguageToggle />
          </nav>
        </div>
      </div>
    </footer>
  );
}
